<template>
  <div class="box">
    <v-row>
      <v-col cols="6">
        <v-row>
          <v-col cols="3"><p class="label">Description</p></v-col>
          <v-col cols="3"><v-text-field :value="profile.ptext" outlined dense hide-details readonly></v-text-field></v-col>
        </v-row>
        <v-row>
          <v-col cols="3"><p class="label">Created by / at</p></v-col>
          <v-col cols="3"><v-text-field :value="profile.modebe" outlined dense hide-details readonly></v-text-field></v-col>
          <v-col cols="3"><v-text-field :value="profile.modDatim | format('yyyy-MM-dd HH:mm:ss')" outlined dense hide-details readonly></v-text-field></v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import share from './searchShare.js';
export default {
  props: {
    profile: {
      type: Object,
    },
  },
  mixins: [share],
};
</script>

<style lang="scss" scoped>
.label {
  text-align: right;
  padding-right: 15px;
}
.v-text-field {
  width: 100%;
}
</style>
